(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root = document) => {
      root.querySelectorAll('[data-dn-carousel]:not([data-dn-carousel-ready])').forEach((carousel) => {
        carousel.dataset.dnCarouselReady = 'true';
        const stage = carousel.querySelector('[data-dn-drag]');
        const slides = Array.from(carousel.querySelectorAll('[data-dn-slide]'));
        if (!stage || !slides.length) return;
        let active = 0;
        let startX = 0;
        let deltaX = 0;
        let pointerId;
        let didDrag = false;
        const render = () => {
          const spacing = Math.min(window.innerWidth * .34, 500);
          slides.forEach((slide, index) => {
            let distance = index - active;
            if (distance > slides.length / 2) distance -= slides.length;
            if (distance < slides.length / -2) distance += slides.length;
            const absolute = Math.abs(distance);
            slide.style.setProperty('--dn-card-x', `${distance * spacing}px`);
            slide.style.setProperty('--dn-card-y', `${Math.min(absolute, 2) * 30}px`);
            slide.style.setProperty('--dn-card-rotate', `${distance * 4.5}deg`);
            slide.style.setProperty('--dn-card-scale', `${Math.max(.72, 1 - absolute * .11)}`);
            slide.style.setProperty('--dn-card-opacity', `${Math.max(.18, 1 - absolute * .25)}`);
            slide.style.setProperty('--dn-card-z', `${20 - absolute}`);
            slide.setAttribute('aria-hidden', absolute > 1 ? 'true' : 'false');
          });
        };
        const move = (direction) => {
          active = (active + direction + slides.length) % slides.length;
          render();
        };
        const previousButton = carousel.querySelector('[data-dn-previous]');
        const nextButton = carousel.querySelector('[data-dn-next]');
        const bindArrow = (button, direction) => {
          if (!button) return;
          button.addEventListener('pointerdown', (event) => event.stopPropagation());
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            move(direction);
          });
        };
        bindArrow(previousButton, -1);
        bindArrow(nextButton, 1);
        stage.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') move(-1);
          if (event.key === 'ArrowRight') move(1);
        });
        stage.addEventListener('pointerdown', (event) => {
          if (event.target.closest('a, button')) return;
          pointerId = event.pointerId;
          startX = event.clientX;
          deltaX = 0;
          didDrag = false;
          stage.setPointerCapture(pointerId);
        });
        stage.addEventListener('pointermove', (event) => {
          if (event.pointerId !== pointerId) return;
          deltaX = event.clientX - startX;
          didDrag = Math.abs(deltaX) > 8;
        });
        stage.addEventListener('pointerup', (event) => {
          if (event.pointerId !== pointerId) return;
          if (Math.abs(deltaX) > 48) move(deltaX < 0 ? 1 : -1);
          pointerId = undefined;
        });
        stage.addEventListener('pointercancel', () => { pointerId = undefined; });
        stage.addEventListener('click', (event) => { if (didDrag) event.preventDefault(); }, true);
        window.addEventListener('resize', render, { passive: true });
        render();
      });
    };
    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const header = document.querySelector('[data-dn-header]');
  if (header) {
    const menu = header.querySelector('details');
    const close = header.querySelector('.dn-header__close');
    menu?.addEventListener('toggle', () => document.body.classList.toggle('menu-open', menu.open));
    close?.addEventListener('click', () => { menu.open = false; });
    menu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => { menu.open = false; }));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["motion-system"]) return;
  try {
    
  (() => {
    if (window.DellaNonnaMotion) return;
    window.DellaNonnaMotion = true;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const splitWords = (root = document) => {
      root.querySelectorAll('[data-dn-reveal]:not([data-dn-split])').forEach((element) => {
        element.dataset.dnSplit = 'true';
        const nodes = Array.from(element.childNodes);
        let index = 0;
        nodes.forEach((node) => {
          if (node.nodeType !== Node.TEXT_NODE || !node.textContent.trim()) return;
          const fragment = document.createDocumentFragment();
          node.textContent.split(/(\s+)/).forEach((part) => {
            if (!part.trim()) {
              fragment.appendChild(document.createTextNode(part));
              return;
            }
            const span = document.createElement('span');
            span.className = 'dn-reveal-word';
            span.style.setProperty('--dn-word-index', index);
            span.textContent = part;
            fragment.appendChild(span);
            index += 1;
          });
          node.replaceWith(fragment);
        });
      });
    };
    const observe = (root = document) => {
      splitWords(root);
      const targets = root.querySelectorAll('[data-dn-reveal]:not([data-dn-observed]),[data-dn-reveal-block]:not([data-dn-observed])');
      if (reduceMotion) {
        targets.forEach((target) => target.classList.add('is-visible'));
        return;
      }
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: .16, rootMargin: '0px 0px -8% 0px' });
      targets.forEach((target) => {
        target.dataset.dnObserved = 'true';
        observer.observe(target);
      });
    };
    const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));
    const renderScroll = () => {
      document.body.classList.toggle('dn-has-scrolled', window.scrollY > 110);
      if (!reduceMotion) {
        document.querySelectorAll('[data-dn-hero]').forEach((hero) => {
          const progress = clamp(-hero.getBoundingClientRect().top / Math.max(hero.offsetHeight, 1));
          hero.style.setProperty('--dn-hero-shift', `${progress * 92}px`);
          hero.style.setProperty('--dn-hero-scale', `${1 + progress * .09}`);
          hero.style.setProperty('--dn-hero-opacity', `${1 - progress * .55}`);
          hero.style.setProperty('--dn-hero-title-shift', `${progress * -32}px`);
          hero.style.setProperty('--dn-hero-title-scale', `${1 - progress * .045}`);
        });
        document.querySelectorAll('[data-dn-stack]').forEach((stack) => {
          const rect = stack.getBoundingClientRect();
          const distance = Math.max(stack.offsetHeight - window.innerHeight, 1);
          const progress = clamp(-rect.top / distance);
          stack.style.setProperty('--dn-stack-y', `${(1 - progress) * window.innerHeight * .9}px`);
          stack.style.setProperty('--dn-stack-scale', `${1 - progress * .18}`);
          stack.style.setProperty('--dn-stack-opacity', `${1 - progress * .42}`);
        });
        document.querySelectorAll('[data-dn-parallax]').forEach((element) => {
          const rect = element.getBoundingClientRect();
          const progress = clamp((window.innerHeight - rect.top) / (window.innerHeight + rect.height));
          element.style.setProperty('--dn-parallax-y', `${(progress - .5) * -70}px`);
          element.style.setProperty('--dn-parallax-rotate', `${(progress - .5) * 3}deg`);
        });
      }
      window.requestAnimationFrame(renderScroll);
    };
    const cursor = document.querySelector('[data-dn-cursor]');
    if (cursor && window.matchMedia('(pointer:fine)').matches && !reduceMotion) {
      window.addEventListener('pointermove', (event) => {
        cursor.style.left = `${event.clientX}px`;
        cursor.style.top = `${event.clientY}px`;
        cursor.classList.add('is-visible');
        cursor.classList.toggle('is-active', Boolean(event.target.closest('a,button,summary,[data-dn-drag]')));
      }, { passive: true });
      document.documentElement.addEventListener('mouseleave', () => cursor.classList.remove('is-visible'));
    }
    const ready = () => window.setTimeout(() => document.body.classList.add('dn-ready'), 180);
    if (document.readyState === 'complete') ready(); else window.addEventListener('load', ready, { once: true });
    window.setTimeout(ready, 1600);
    observe();
    window.requestAnimationFrame(renderScroll);
    document.addEventListener('shopify:section:load', (event) => observe(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
